import {Features} from 'constants/plan-access/features';
import {useSafeCurrentCompanyUuid} from 'ui/@atoms/current-company';
import {useCompany} from './queries/use-company';
import {useCurrentSubscriptions} from './queries/use-current-subscriptions';
import useHasPlanAccess from './use-has-plan-access';

/**
 * Whether Instill Beats is shown for the current company.
 *
 * The API decides whether Beats is on and says so on the company payload, so
 * the web app carries no switch of its own that could disagree with it.
 * Beats also needs Instill Flow: its signals come from meeting analysis, and
 * a company without Flow would be shown a section that can never fill.
 *
 * `isLoading` covers both the company and its subscriptions. Until they
 * have loaded the plan reads as free and the switch as off, so a guard that
 * decides earlier would turn people away from a page they may open.
 */
const useBeatsEnabled = () => {
  const companyUuid = useSafeCurrentCompanyUuid();
  const {hasPlanAccess} = useHasPlanAccess();

  const company = useCompany({variables: {companyUuid}});
  const subscriptions = useCurrentSubscriptions({variables: {companyUuid}});

  return {
    isBeatsEnabled:
      !!company.data?.beatsEnabled && hasPlanAccess(Features.INSTILL_FLOW),
    isLoading: company.isLoading || subscriptions.isLoading,
  };
};

export default useBeatsEnabled;
